import { useState } from 'react';

import { ChangeEmailDialog } from '@/components/account/change-email-dialog';
import { Button } from '@/components/ui/button';

/**
 * The sign-in address, shown and changeable on the payment page (ESCLOUD-331).
 * The address is the user's chance to catch a typo - Auth0's signup form has a
 * single email field, and nothing checks it again before payment.
 *
 * The dialog itself is the shared `ChangeEmailDialog` (ESCLOUD-334): the
 * payment page has no tenant yet, so it passes the intent's region explicitly
 * instead of relying on the tenant context fallback.
 */
export function EmailCard({
    email,
    region,
    onChanged,
}: {
    email: string;
    region: string;
    onChanged: (email: string) => void;
}) {
    const [open, setOpen] = useState(false);

    return (
        <div className="rounded-xl border border-border bg-card p-5">
            <div className="mb-2 flex items-center justify-between gap-3">
                <span className="text-sm font-semibold text-foreground">{email}</span>
                <Button
                    type="button"
                    variant="link"
                    className="h-auto p-0 text-[13px] font-medium text-primary"
                    onClick={() => setOpen(true)}
                >
                    Change
                </Button>
            </div>
            <p className="m-0 text-[13px] text-muted-foreground">
                Receipts and the verification email go to this address.
            </p>

            <ChangeEmailDialog
                open={open}
                onOpenChange={setOpen}
                currentEmail={email}
                region={region}
                onChanged={onChanged}
            />
        </div>
    );
}
